//Окрыть всплывающий поиск.
function show_search(e) {
    if (!e) e = window.event;

    if (e.stopPropagation) {
        e.stopPropagation();
    }
    else {
        e.cancelBubble = true;
    }

    var hide = $('#search-box').data('hide');
    if(hide==1){
        $('#search-box').removeClass('hide');
        $('#search-box').data('hide', 0);
        $('body').addClass('only-screen');
        $('.search-button').addClass('active');
    }
    else{
        close_search();
    }
}

//Закрыть всплывающий поиск.
function close_search() {
    $('body').removeClass('only-screen');
    $('#search-box').addClass('hide');
    $('#search-box').data('hide', 1);
    $('.search-button').removeClass('active');
}

//Закрытие карточки врача при клике вне блока
$(document).mouseup(function (e) {
    var div2 = $("#search-box__full");
    var div3 = $("#search-box");
    var div4 = $(".search-button");
    if (!div2.is(e.target)
        && div2.has(e.target).length === 0 && !div3.hasClass('hide') && div4.has(e.target).length === 0) {
        close_search();
    }
});